import { render, staticRenderFns } from "./GoogleAds.vue?vue&type=template&id=f9ca6986&scoped=true"
import script from "./GoogleAds.vue?vue&type=script&lang=js"
export * from "./GoogleAds.vue?vue&type=script&lang=js"
import style0 from "./GoogleAds.vue?vue&type=style&index=0&id=f9ca6986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ca6986",
  null
  
)

export default component.exports